<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('exportDonne.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <qd-message :title="$t('exportDonne.info.title')" class="mgt-20px"
               type="is-info">
      <span v-html="$t('exportDonne.info.message')"></span>
    </qd-message>
    <div class="columns is-multiline mgt-20px">
      <qd-collapse class="column is-12 card is-paddingless mgb-20px" animation="slide"
        v-for="(typeExport, index) in typesExports" :key="index">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3">
            <p class="card-header-title">
              {{ $t(typeExport.title) }}
            </p>
            <a class="card-header-icon">
              <b-icon
                :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <error-msg-component :messages="typeExport.messages"
                                :messagesChampsVide="typeExport.messagesChampsVide"
                                :champsVide="typeExport.champsVide"
                                :error="typeExport.isError"
                                title="general.problemOccurred"
                                :withEmplyFields="false"
                                @close="typeExport.isError = false"/>
          <div class="content">
            <span v-html="$t(typeExport.description)"></span>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item"
             @click="exportToExcel(typeExport.type)">
            {{ $t('exportDonne.actions.exporter') }}
          </a>
        </footer>
      </qd-collapse>
    </div>
    <a ref="lienDownloadExportExcelAdmin"></a>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import * as Config from '@/configuration/import/importConf';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import exportExcelAdmin from '@/api/exportExcelAdmin';
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'exportData',
  data() {
    return {
      typesExports: cloneDeep(Config.TYPE_EXPORT_DATA),
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
  },
  methods: {
    async exportToExcel(type) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const query = {
          typeDonnee: type,
          typeExport: '',
          filtres: {
            query: {
              societeId: this.societeActiveId,
            },
          },
        };
        const response = await exportExcelAdmin(query);
        const link = this.$refs.lienDownloadExportExcelAdmin;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('exportDonne.breadcrumb.config'), route: '', isActive: true },
      ];
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    this.setInformationPage(this.$t('pageConfigInterne.exportDonnee'));
  },
};
</script>
